import Cookies from 'js-cookie'
// import { IS_Electron } from '@/utils/index'

const TokenKey = 'P-Token'
const TokenUser = 'mind-user'
const TokenUserName = 'mind-uname'

function getDomain() {
  let domain = document.domain
  let domainArray = domain.match(/\./g)
  let mainHost
  // console.log(domainArray,process.env.NODE_ENV);
  if(domainArray){
    if(domainArray && domainArray.length>1){
        let domainList = domain.split('.');
        let urlItems   = [];
        urlItems.unshift(domainList.pop() );
        while(domainList.length) {
            urlItems.unshift(domainList.pop() );
            mainHost = urlItems.join( '.' );
            break;
        }
        return "."+mainHost;
    }
  }else{
    return process.env.NODE_ENV != 'production'?"localhost":".aiseesoft.com";
  }
}

export function getLocalStorageForCropper(...keys) {
  const values = {}; // 创建一个空对象来存储每个键对应的值

  // 遍历传入的键数组
  keys.forEach(key => {
    // 使用 getLocalStorage 方法获取指定键对应的值
    const value = getLocalStorage(key);

    // 将键值对存储到 values 对象中
    values[key] = value;
  });

  // 返回每个键对应的值
  return values;
}

export function setLocalStorage(name,val){

  // #ifdef APP-PLUS
  
  // #endif
  // #ifdef H5
  localStorage.setItem(name, val);

  // #endif
  // PC 客户端存储登录状态，是否过期
}

export function setSessionStorage(name,val){
  // #ifdef APP-PLUS
    sessionStorage.setItem(name, val);
}

export function getSessionStorage(name){
  return sessionStorage.getItem(name);
}

export function getLocalStorage(name){
   // #ifdef H5
  return localStorage.getItem(name);
  // #endif
}
export function removeLocalStorage(name){
  // #ifdef H5
  localStorage.removeItem(name);
  // #endif
}
export function removeAllLocalStorage(){
  // #ifdef H5
  localStorage.clear();
  // #endif
}

export function getUserType() {
  return Cookies.get('userTypekey')
}

export function setUserType(userType) {
  return Cookies.set('userTypekey',userType)
}

export function getToken() {
  return getCookie(TokenKey)
}
export function setToken(token) { 
  return setCookie(TokenKey,token)
}

export function removeToken() {
  let hostdomain = getDomain() 
  if(hostdomain){
    Cookies.remove(TokenKey,{path:"/",domain: hostdomain})
  }
  return Cookies.remove(TokenKey)
}

export function removeCookie(TokenKey) {
  console.log(TokenKey);
  let hostdomain = getDomain() 
  if(hostdomain){
    Cookies.remove(TokenKey,{path:"/",domain: hostdomain})
  }
  return Cookies.remove(TokenKey)
}

export function getUUID() {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d')
  ctx.font = '14px Arial'
  ctx.fillStyle = '#ccc'
  ctx.fillText('mind, user', 2, 2)
  return canvas.toDataURL('image/jpeg')
}

export function getUser() {
  return Cookies.get(TokenUser)
}

export function setUser(userInfo) {
  return Cookies.set(TokenUser, userInfo)
}

export function removeTokenExpire() {

  let hostdomain = getDomain() 
  if(hostdomain){
    Cookies.remove(TokenKey,{path:"/",domain: hostdomain})
  }
  return Cookies.remove(TokenUser,{path: '',domain: hostdomain})
}

export function getUserName() {
  return Cookies.get(TokenUserName)
}

export function setUserName(userInfo) {
  setLocalStorage(TokenUserName,userInfo)
  return Cookies.set(TokenUserName, userInfo)
}

export function setCookie(name,value){
  var Days = 30;
  var exp = new Date();
  exp.setTime(exp.getTime() + Days*24*60*60*30);
  let hostdomain = getDomain();
  // 修复 2023092118:23 @mei
  document.cookie = name + "="+ value +";expires="+ exp.toGMTString();+";path=/;domain="+hostdomain;
}

export function getCookie(name){
  var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
  if(arr=document.cookie.match(reg))
  return unescape(arr[2]);
  else
  return null;
}

// 根据不同的权益展示设置对应的值
export function setLocalStorageOptions(type) {
  console.log(type)
    const settings = {
        'fBProduction': type === 'fBProduction' ? true : false,
        'insBalance': type === 'insBalance' ? true : false,
        'multipleLimit': type === 'multipleLimit' ? true : false,
        'freeGift': type === 'freeGift' ? true : false,
        'fileSizeMsg': type === 'fileSizeMsg' ? true : false,
        'fileSizeMsg4K': type === 'fileSizeMsg4K' ? true : false,
        'fileSizeMsg10M': type === 'fileSizeMsg10M' ? true : false,
        'fileSizeMsg1920K': type === 'fileSizeMsg1920K' ? true : false,
        'unableToBatchDownload': type === 'unableToBatchDownload' ? true : false,
        'insBalanceVip': type === 'insBalanceVip' ? true : false,
        'waterfreeGift': type === 'waterfreeGift' ? true : false,
        'waterinsBalance': type === 'waterinsBalance' ? true : false,
        'waterinsBalanceVip': type === 'waterinsBalanceVip' ? true : false,
        'fileSizeMsg12288K': type === 'fileSizeMsg12288K' ? true : false,
        'enhanceInsBalance': type == 'enhanceInsBalance' ? true : false,
        'enhanceFreeGift': type == 'enhanceFreeGift' ? true : false,
        'enhanceInsBalanceVip': type == 'enhanceInsBalanceVip' ? true : false,
        'enhancefBProduction': type == 'enhancefBProduction' ? true : false
    };
    for (const [key, value] of Object.entries(settings)) {
        setLocalStorage(key, value);
    }
}